export default __webpack_public_path__ + "static/media/greenTick.9087251f.svg";